export default __webpack_public_path__ + "static/media/HASSAN_NL_SEQ17.b7353379.mp3";